import src from "IMAGE";
export default { src, width: 1535, height: 335, blurWidth: 0, blurHeight: 0};
